// UI-related constants
import { MainMenuOptions } from 'src/types';

/**
 * Amount to increment/decrement zoom level
 */
export const ZOOM_INCREMENT = 0.1;

/**
 * Minimum allowed zoom level
 */
export const MIN_ZOOM = 0.01;

/**
 * Maximum allowed zoom level
 */
export const MAX_ZOOM = 4;

/**
 * Extra tile-space allowance for icons, labels, and connector strokes when
 * fitting visible drawing content.
 */
export const FIT_TO_VIEW_TILE_PADDING = 0.75;

/**
 * Minimum screen-space margin around a fitted drawing, in pixels.
 */
export const FIT_TO_VIEW_SCREEN_PADDING = 32;

/**
 * Size of transform control anchor points
 */
export const TRANSFORM_ANCHOR_SIZE = 30;

/**
 * Color for transform controls (selection handles)
 */
export const TRANSFORM_CONTROLS_COLOR = '#0392ff';

/**
 * Main menu options displayed in the application menu
 */
export const MAIN_MENU_OPTIONS: MainMenuOptions = [
  'ACTION.OPEN',
  'EXPORT.JSON',
  'EXPORT.PNG',
  'ACTION.CLEAR_CANVAS',
  'LINK.DISCORD',
  'VERSION'
];
